import { Button, Divider, Stack, styled, SxProps } from '@mui/material';

type ComposeDraftProps = {
  'data-is-post': boolean;
};

export const DiscardButton = styled(Button)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.focus,
  },
}));

export const DraftTitle = styled('h3')(() => ({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 'var(--preference-button-line-clamp)',
  display: '-webkit-box',
  fontSize: 'var(--font-baseline)',
  fontWeight: 'var(--font-medium)',
  overflow: 'hidden',
  textWrap: 'wrap',
}));

export const DraftTypeIndicator = styled(Divider)<ComposeDraftProps>(
  ({ 'data-is-post': isPost, theme }) => ({
    backgroundColor: theme.palette[isPost ? 'secondary' : 'tertiary'].main,
    height: 'var(--preference-compose-header-top-border-width)',
  }),
);

export const DraftWrapper = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: 'var(--border-radius-medium)',
  color: theme.palette.primary.contrastText,
  minWidth: 'var(--preference-compose-draft-width)',
  overflow: 'hidden',
  width: '100%',
}));

export const Footer = styled('footer')(({ theme }) => ({
  '& .MuiButton-root': {
    '&:is(:focus, :focus-visible, :hover, .Mui-focusVisible)': {
      backgroundColor: theme.palette.action.focus,
    },
    borderColor: 'inherit',
    color: 'inherit',
  },
  '& a.MuiButton-root': {
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
  },
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: 'var(--spacing-small)',
  justifyContent: 'flex-start',
  padding: '0 var(--spacing-medium) var(--spacing-medium)',
}));

export const Header = styled('header')(() => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: 'var(--spacing-small)',
  justifyContent: 'flex-start',
  padding: 'var(--spacing-medium)',
}));

export const PopoverStyles: SxProps = {
  // Popover is set right above the trigger, so we need to move it up to look nice
  marginTop: 'calc(-1 * var(--spacing-small))',
};
